
<div :id="content.idHTML" :class="jel_getClassObject(content)">
  <!-- Texte du haut pour promo non valide ou expirée (Activé par SET_IS_PROMO_NOT_VALID dans le store) -->
  <p v-if="isPromoNotValid" class="promo-warning-top" v-html="texteHautPromoExpireeBienvenue" />

  <p
    v-else
    class="sousTitre text-center texte-padding mt-0 px-1"
    label-for="offreBienvenue"
    v-html="texteOffreBienvenue"
  />

  <b-form-radio-group id="offre" plain name="choixOffreBienvenue" class="text-center">
    <EditableArea
      v-if="hasInfo"
      :content="content.formulaire"
      :parentTemplateId="metadata['mgnl:template']"
    />
  </b-form-radio-group>
  <div class="text-center">
    <p
      v-if="texteRegleOffreBienvenue"
      class="prefix-modalites"
      v-html="texteRegleOffreBienvenue"
    />
    <Hyperlien class="pt-1" :content="getContentHyperlien" />
  </div>
</div>
